import { Point } from '../utils/types';

/**
 * Generates an auto path with random points for the bee to follow.
 * The path will last at least minPathTime milliseconds.
 * @param minPathTime Minimum total time (ms) for the path
 * @param width Canvas width (default 400)
 * @param height Canvas height (default 700)
 * @returns Array of points [{x, y, time, rotation}]
 */
export const generateInitAutoPath = (minPathTime: number, width = 400, height = 700): Point[] => {
  const points: Point[] = [];

  // Always add a start point at time 0
  points.push({ x: 0, y: 0, time: 0, rotation: 0 });

  // Add an end point at minPathTime
  // The x, y, rotation for the end point don't matter for visual animation
  points.push({ x: 0, y: 0, time: minPathTime, rotation: 0 });

  // Normalize points to 0-1 for x/y
  // These normalized coordinates are not used for visual bee animation,
  // but the 'time' property of the last point is used for total duration.
  return points.map(p => ({
    x: p.x / width,
    y: p.y / height,
    time: p.time,
    rotation: p.rotation
  }));
};